import { Lock } from "lucide-react";

export function ComingSoon({ title, description, className = "" }) {
  return (
    <div
      className={`relative rounded-xl border border-dashed border-zinc-800 bg-zinc-900/40 p-6 ${className}`}
      data-testid="coming-soon-card"
    >
      <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#E53E3E] bg-[#E53E3E]/10 px-2.5 py-1 rounded-full">
        <Lock className="w-3 h-3" /> Coming Soon
      </span>
      <h3 className="mt-3 font-display text-lg font-bold uppercase tracking-tight text-white">{title}</h3>
      {description && <p className="mt-1 text-sm text-zinc-500 leading-relaxed">{description}</p>}
    </div>
  );
}
